<template>
  <button class="gitex-btn" :class="{'gitex-btn--transparent': props.transparent}">
    <slot />
  </button>
</template>

<script setup lang="ts">
const props = defineProps<{
  transparent?: boolean
}>()
</script>

<style scoped lang="scss">
.gitex-btn {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 16px 40px;
  background: #E31E33;
  border-radius: 8px;
  height: 48px;
  border: none;
  outline: none;
  cursor: pointer;
  transition: all .2s ease-in-out;
  font-weight: 600;
  font-size: 16px;
  line-height: 16px;
  text-align: center;
  letter-spacing: 0.02em;
  color: #FFFFFF;

  &:hover {
    background: rgba(223, 30, 59, 0.85);
  }

  &--transparent {
    border: 1px solid #E31E33;
    background: transparent;
    color: #E31E33;

    &:hover {
      background: rgba(223, 30, 59, 0.10);
    }
  }
}
</style>
